import { WarningAction, ErrorAction } from 'common/redux/toasts'
import { select, put } from 'redux-saga/effects'
import { ESTADO } from '../../MainPresupuestador.constants'
import {
  PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER,
  PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR,
  PRESUPUESTADOR_SELECT_STOCK,
  PRESUPUESTADOR_SET_PRICE_INCREASE
} from '../constants';
import { STOCK_STATES } from 'presupuestador/Constants';

export default function* showPresupuestoAlertsSaga() {
  const {
    presupuestador,
    router: { location }
  } = yield select(state => state)

  const locationMode = location.pathname.split('/')[2]
  const isModeEdit = locationMode === 'editar'
  const isLastBudgetEdit = locationMode === 'ultimo-editado'
  const isModeView = locationMode === 'ver'

  if (isModeEdit && presupuestador?.alerts?.length > 0) {
    ErrorAction({
      title:
        'Para visualizar el presupuesto inicial volvé al listado e ingresa en modo observador.'
    })
  }

  const noValidStockStates = [STOCK_STATES.PRONTO_EN_STOCK, STOCK_STATES.SUJETO_A_DEFINICION, STOCK_STATES.NO_A_LA_VENTA]
  if (
    isModeView &&
    presupuestador.state !== ESTADO.RESERVADO &&
    presupuestador.state !== ESTADO.ANULADO &&
    presupuestador.state !== ESTADO.CERRADO &&
    !noValidStockStates.includes(presupuestador.stock_estado) &&
    presupuestador?.nuevo?.published
  ) {
    ErrorAction({
      title: 'Para realizar cambios volvé al listado e ingresa en modo editor.'
    })
  }

  const historicalStates = [ESTADO.RESERVADO, ESTADO.CERRADO, ESTADO.ANULADO]
  const isHistoricalBudget = historicalStates.includes(presupuestador.state)

  if (presupuestador.alerts && !isHistoricalBudget) {
    presupuestador.alerts.forEach(alert => {
      WarningAction({
        title: alert.message
      })
    })

    if(isModeEdit || isLastBudgetEdit) {
      if(presupuestador.alerts.some(alert => alert.type === "priceProduct")) {
        yield put({
          type: PRESUPUESTADOR_SET_PRICE_INCREASE,
          data: { resale_price_increase: 0 }
        })
      }
      const deleteSpecialBonif = presupuestador.alerts.some(alert => alert.type === "pricing" || alert.type === "priceProduct" || alert.type === "exchangeRate" || alert.type === "stockVinState")
      
      if(deleteSpecialBonif) {
        yield put({
          type: PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER,
          data: { special_discount: null }
        })
      }

      const deleteExtraBonif = presupuestador.alerts.some(alert => alert.type === "pricing" || alert.type === "takingCar" || alert.type === "priceProduct" ||  alert.type === "stockVinState")
      if(deleteExtraBonif) {
        yield put({
          type: PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR
        })
      }

      const deleteStockVin = presupuestador.alerts.some(alert => alert.type === "stockVinState")
      if (deleteStockVin) {
          const entregaUsados = presupuestador.entregaUsados.map(usado => {
            usado.take_improvement_amount = 0;
            usado.final_take_price = usado.updatedTakePrice || usado.original_price;
            
            return usado;
          });
        yield put({
          type: PRESUPUESTADOR_SELECT_STOCK,
          data: {
            selectedStock: null,
            stock_id: null,
            stock_color: null,
            stock_ubicacion: null,
            stock_vin: null,
            stock_sucursal: null,
            stock_estado: null,
            special_discount: 0,
            entregaUsados
          },
        })
      }
    }
  }
}
